"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Field = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_jss_1 = __importDefault(require("react-jss"));
const react_markdown_1 = __importDefault(require("react-markdown"));
const icons_1 = require("../../../../icons");
const links_1 = require("../../../utils/links");
const field_style_1 = __importDefault(require("./field.style"));
const lockFieldTooltip = 'Persist this value across forms';
const unlockFieldTooltip = 'Disable persistence of this value across forms';
const lockedFieldTooltip = "This field is locked across all forms. To make this field's value unique, disable the persistence lock from the main form.";
const linkFieldTooltip = 'Persist this value from the main form';
const unlinkFieldTooltip = 'Disable persistence of this value from the main form';
class Field extends react_1.PureComponent {
    renderDescription() {
        const { classes, schema, rawDescription } = this.props;
        if (rawDescription && schema.type !== 'object')
            return (jsx_runtime_1.jsx("div", Object.assign({ className: classes.rawDescription }, { children: jsx_runtime_1.jsx(react_markdown_1.default, { source: rawDescription }, void 0) }), void 0));
        return null;
    }
    renderLinkIcon() {
        const { classes, id, formContext = {} } = this.props;
        // handle links between forms
        const { links } = formContext;
        const { id: formId, isMainForm, onClickLock, lockedPaths = [], onClickLink, linkedPaths = [] } = (links || {});
        const fieldPath = links_1.getFieldPath(formId, id);
        const isLockedField = lockedPaths.includes(fieldPath);
        const isLinkedField = !isLockedField && linkedPaths.includes(fieldPath);
        const canLinkField = links_1.canLink(fieldPath);
        let linkIcon = null;
        if (links && canLinkField) {
            if (isMainForm) {
                const onClick = () => onClickLock(fieldPath);
                linkIcon = isLockedField ? (jsx_runtime_1.jsx("div", Object.assign({ className: classes.lockIconClose, "data-is-clickable": true, onClick: onClick, title: unlockFieldTooltip, "data-cy": "unlock" }, { children: jsx_runtime_1.jsx(icons_1.Icon, { name: "PadlockCloseFill", size: 20 }, void 0) }), void 0)) : (jsx_runtime_1.jsx("div", Object.assign({ className: classes.lockIconOpen, onClick: onClick, title: lockFieldTooltip, "data-cy": "lock" }, { children: jsx_runtime_1.jsx(icons_1.Icon, { name: "PadlockOpen", size: 20 }, void 0) }), void 0));
            }
            else if (isLockedField) {
                linkIcon = (jsx_runtime_1.jsx("div", Object.assign({ className: classes.lockIconClose, title: lockedFieldTooltip }, { children: jsx_runtime_1.jsx(icons_1.Icon, { name: "PadlockCloseFill", size: 20 }, void 0) }), void 0));
            }
            else {
                const onClick = () => onClickLink(fieldPath);
                linkIcon = isLinkedField ? (jsx_runtime_1.jsx("div", Object.assign({ className: classes.unlinkIcon, onClick: onClick, title: unlinkFieldTooltip, "data-cy": "unlink" }, { children: jsx_runtime_1.jsx(icons_1.Icon, { name: "DuplicateFill", size: 20 }, void 0) }), void 0)) : (jsx_runtime_1.jsx("div", Object.assign({ className: classes.linkIcon, onClick: onClick, title: linkFieldTooltip, "data-cy": "link" }, { children: jsx_runtime_1.jsx(icons_1.Icon, { name: "Duplicate", size: 20 }, void 0) }), void 0));
            }
        }
        return {
            linkIcon,
            isLargeLabel: !isMainForm && !isLockedField
        };
    }
    render() {
        const { classes, id, label, children, rawHelp, hidden, required, displayLabel } = this.props;
        if (hidden)
            return children;
        // handle links between forms
        const { linkIcon, isLargeLabel } = this.renderLinkIcon();
        const labelProps = {
            className: classes.label,
            htmlFor: id,
            'data-input-is-required': required,
            'data-is-large': isLargeLabel
        };
        return (jsx_runtime_1.jsxs("div", Object.assign({ className: classes.fieldWrapper }, { children: [jsx_runtime_1.jsxs("div", Object.assign({ className: classes.field }, { children: [displayLabel && label && (jsx_runtime_1.jsxs("div", Object.assign({ className: classes.labelWrapper }, { children: [jsx_runtime_1.jsx("label", Object.assign({}, labelProps, { children: jsx_runtime_1.jsx("span", { children: label }, void 0) }), void 0), linkIcon] }), void 0)), this.renderDescription(), children] }), void 0),
                rawHelp && jsx_runtime_1.jsxs("div", Object.assign({ className: classes.rawHelp }, { children: [" ", rawHelp] }), void 0)] }), void 0));
    }
}
exports.Field = Field;
Field.defaultProps = {
    label: undefined,
    rawDescription: undefined,
    rawErrors: [],
    rawHelp: '',
    hidden: false,
    required: false,
    readonly: false,
    disabled: false,
    displayLabel: true
};
exports.default = react_jss_1.default(field_style_1.default)(Field);
//# sourceMappingURL=index.js.map